var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "facebook",
    d: "M-20395,13642h-.156a17.5,17.5,0,0,0,2.15-.156v-12.771h4.42l.7-5.729h-5.127v-3.948c0-1.673.467-2.787,2.713-2.787h2.9v-5.123a37.49,37.49,0,0,0-4.219-.226c-4.34,0-7.035,2.9-7.035,7.569v4.512h-4.609v5.728h4.609v12.6a20.027,20.027,0,0,1-11.658-6.8,19.866,19.866,0,0,1-3.439-5.9A19.865,19.865,0,0,1-20415,13622a19.875,19.875,0,0,1,1.572-7.785,19.909,19.909,0,0,1,4.285-6.357,19.936,19.936,0,0,1,6.357-4.287A19.866,19.866,0,0,1-20395,13602a19.882,19.882,0,0,1,7.785,1.572,19.92,19.92,0,0,1,6.357,4.287,19.914,19.914,0,0,1,4.287,6.357A19.91,19.91,0,0,1-20375,13622a19.892,19.892,0,0,1-1.572,7.782,19.925,19.925,0,0,1-4.287,6.357,19.917,19.917,0,0,1-6.357,4.286A19.882,19.882,0,0,1-20395,13642Zm-.2,0h-.129a17.475,17.475,0,0,1-3.322-.318v-.016a20.04,20.04,0,0,0,3.451.332Z",
    transform: "translate(20415 -13601.999)",
    fill: "#1877f2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookMedium);
export default __webpack_public_path__ + "static/media/facebook-medium.b489aa74.svg";
export { ForwardRef as ReactComponent };